
import React, { useState, useEffect } from "react";

function Sidebar({ setIframeSrc, activeLevel, isDepartmentUser, isMarketUser, isRiskAnalyst,activeMenu, setActiveMenu }) {

//   const [activeMenu, setActiveMenu] = useState("");


  const menuConfig = {
    level1: ["daily", "monthly", "quarterly"],
    level2a: ["daily", "quarterly", "annually"],
    level2b: ["monthly", "quarterly"]
  };


  const getMenusByLevel = () => {
    let menus = menuConfig[activeLevel] || [];

    // 🔴 Risk Analyst Rule
    if (isRiskAnalyst && activeLevel === "level1") {
      return [...menus, "allbreaches"]; // add extra menu
    }

    // 🔵 Department User Rules
    if (isDepartmentUser) {
      if (activeLevel === "level1") {
        return menus.filter((menu) => menu !== "quarterly");
      }
    }

    // 🟢 Market User Rules
    if (isMarketUser) {
      if (activeLevel === "level1") {
        return menus.filter((menu) =>
          ["daily", "monthly"].includes(menu)
        );
      }

      if (activeLevel === "level2a") {
        return menus.filter((menu) =>
          ["daily", "monthly", "quarterly"].includes(menu)
        );
      }

      if (activeLevel === "level2b") {
        return menus.filter((menu) =>
          ["monthly"].includes(menu)
        );
      }
    }

    return menus;
  };

  useEffect(() => {
    const menus = getMenusByLevel();

    if (menus.length > 0) {
      const defaultMenu = menus[0]; // always first allowed menu
      setActiveMenu(defaultMenu);
      handleClick(defaultMenu, activeLevel);
    }
  }, [activeLevel]);


  const handleClick = (menu, levelParam) => {
    const level = levelParam || activeLevel;
    setActiveMenu(menu);

    let url = "";

    // ✅ LEVEL 1 URLs
    if (level === "level1") {
      if (menu === "daily") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level1_daily/Dashboard5?:showVizHome=no";
      }
      else if (menu === "monthly") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level1_monthly/Dashboard5?:showVizHome=no";
      }
      else if (menu === "quarterly") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_quartely1_newdataformat/Dashboard5?:showVizHome=no";
      }
      else if (menu === "allbreaches") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_quartely1_redzone/Dashboard62?:showVizHome=no";
      }
    }

    // ✅ LEVEL 2A URLs
    else if (level === "level2a") {
      // if (menu === "daily") {
      //   url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily/Dashboard5?:showVizHome=no";
      // } 

      // this is for all the 4 reporting date
      // if (menu === "daily") {
      //   url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata/Dashboard1?:showVizHome=no";
      // }
      //  if (menu === "daily") {
      //   url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata1/Dashboard1?:showVizHome=no";
      // } 
      // this related to two reporting dates
      // if (menu === "daily") {
      //   url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_newdata2/Dashboard1?:showVizHome=no";
      // }

      // this related to 3 reporting dates
      if (menu === "daily") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_daily_3date/Dashboard1?:showVizHome=no";
      }
      else if (menu === "quarterly") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_quarterly/Dashboard5?:showVizHome=no";
      }
      else if (menu === "annually") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2A_annually/Dashboard5?:showVizHome=no";
      }
    }


    // LEVEL 2B URLs
    else if (level === "level2b") {
      if (menu === "monthly") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2B_monthly/Dashboard5?:showVizHome=no";
      }
      else if (menu === "quarterly") {
        url = "https://public.tableau.com/views/Risk_appetite_monitoring_level2B_annually1/Dashboard5?:showVizHome=no";
      }
    }

    setIframeSrc(url);
  };

  return (
    <div style={styles.sidebar}>
      <ul style={styles.menu}>
        {getMenusByLevel().map((menu) => (
          <li
            key={menu}
            style={{
              ...styles.menuItem,
              ...(activeMenu === menu ? styles.active : styles.inactive)
            }}
            onClick={() => handleClick(menu)}
          >
            {/* {menu.charAt(0).toUpperCase() + menu.slice(1)} */}
            {menu === "allbreaches"
              ? "All Breaches"
              : menu.charAt(0).toUpperCase() + menu.slice(1)}
          </li>
        ))}
      </ul>
    </div>
  );
}

const styles = {
  sidebar: {
    width: "220px",
    height: "86vh",
    backgroundColor: "#ffffff",
    padding: "20px",
    boxSizing: "border-box"
  },
  menu: {
    listStyle: "none",
    padding: 0
  },
  menuItem: {
    padding: "12px 10px",
    cursor: "pointer",
    borderRadius: "4px",
    marginBottom: "10px",
    color: "#fff"
  },
  active: {
    backgroundColor: "#0072DA"
  },
  inactive: {
    backgroundColor: "#9CC9F5"
  }
};

export default Sidebar;
